import { roundN } from "../../utils/functions/roundN";
import { Emdash } from "../Punctuation";

// // // //

/**
 * DataGridYearValue
 * Render a year value in DataGridCell
 */
export function DataGridYearValue(props: { value: number }) {
    const { value } = props;
    if (typeof value !== "number") {
        return <Emdash />;
    }

    if (value === 0) {
        return (
            <>
                {value.toFixed(0)}
                <> yrs</>
            </>
        );
    }

    return (
        <>
            {roundN(value, 3).toFixed(3)}
            <> yrs</>
        </>
    );
}
